import { t } from "@lingui/core/macro";
import { Chip } from "@heroui-v3/react";

type WaitlistStatus =
  | "waiting"
  | "notified"
  | "booked"
  | "declined"
  | "expired"
  | "cancelled";

const STATUS_COLOR: Record<
  WaitlistStatus,
  "default" | "accent" | "success" | "warning" | "danger"
> = {
  waiting: "accent",
  notified: "warning",
  booked: "success",
  declined: "default",
  expired: "danger",
  cancelled: "default",
};

export function WaitlistStatusChip({ status }: { status: WaitlistStatus }) {
  const label = (() => {
    switch (status) {
      case "waiting":
        return t`V čakanju`;
      case "notified":
        return t`Obveščen`;
      case "booked":
        return t`Rezerviran`;
      case "declined":
        return t`Zavrnjen`;
      case "expired":
        return t`Potekel`;
      case "cancelled":
        return t`Preklican`;
    }
  })();

  return (
    <Chip size="sm" color={STATUS_COLOR[status]} variant="soft">
      {label}
    </Chip>
  );
}
